import React, {Fragment, useEffect, useState} from "../../_snowpack/pkg/react.js";
import {Transition, Dialog} from "../../_snowpack/pkg/@headlessui/react.js";
const AmiiboDialog = ({amiiboState, darkMode}) => {
  const [show, setShow] = useState(false);
  const [amiibo, setAmiibo] = amiiboState;
  useEffect(() => {
    if (amiibo !== null) {
      setShow(true);
    }
  }, [amiibo]);
  useEffect(() => {
    if (!show) {
      setTimeout(() => setAmiibo(null), 200);
    }
  }, [show]);
  return /* @__PURE__ */ React.createElement(Transition, {
    appear: true,
    show,
    as: Fragment
  }, /* @__PURE__ */ React.createElement(Dialog, {
    as: "div",
    className: `${darkMode ? "dark" : ""} fixed inset-0 z-10 overflow-y-auto`,
    onClose: () => setShow(false)
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex items-center justify-center min-h-screen p-4"
  }, /* @__PURE__ */ React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, /* @__PURE__ */ React.createElement(Dialog.Overlay, {
    className: "fixed inset-0 bg-black opacity-30"
  })), /* @__PURE__ */ React.createElement(Transition.Child, {
    as: Fragment,
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 scale-95",
    enterTo: "opacity-100 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 scale-100",
    leaveTo: "opacity-0 scale-95"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "relative bg-white dark:bg-gray-700 dark:text-white rounded-2xl max-w-sm md:max-w-md lg:max-w-lg xl:max-w-lg w-full mx-auto p-6"
  }, /* @__PURE__ */ React.createElement(Dialog.Title, {
    as: "h3",
    className: "font-header text-xl font-bold leading-6 text-gray-900 dark:text-white"
  }, amiibo?.character), /* @__PURE__ */ React.createElement("ul", {
    className: "mt-2"
  }, /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, "Name: "), amiibo?.name), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, "Franchise: "), " ", amiibo?.gameSeries), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, "Series: "), amiibo?.amiiboSeries), /* @__PURE__ */ React.createElement("li", null, /* @__PURE__ */ React.createElement("b", null, "Released: "), new Date(amiibo?.release.na ?? "").toLocaleDateString("en-GB") ?? "Unreleased")), /* @__PURE__ */ React.createElement("div", {
    className: "mt-4 flex flex-row justify-end"
  }, /* @__PURE__ */ React.createElement("button", {
    type: "button",
    className: "font-semibold px-4 py-2 text-sm text-red-900 dark:text-gray-800 bg-red-100 dark:bg-gray-300 border border-transparent rounded-md hover:bg-red-200 dark:hover:bg-gray-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-red-500",
    onClick: () => setShow(false)
  }, "Close")))))));
};
export default AmiiboDialog;
